import { Typography } from "@mui/material"

export const Note = ({ note }: { note: string }) => {
  return <Typography variant="note">{note}</Typography>
}
